<template>
    <div>
        <div class="matchingItemImages">
            <div class="matchingImage">
                <figure>
                    <img src="/images/manager/matching/matching1.png" alt="미국 국기" />
                </figure>
                <div>
                    <h6 style="color: #294A7A;">보낸 기업</h6>
                    <h3 style="color: #294A7A; font-weight: 700;">
                        (주)행복을 만드는 사람들
                    </h3>
                    <h5 style="font-weight: 350; margin-top: 24px;">032-222-3333</h5>
                    <h5 style="font-weight: 350;">asdfsadf@naver.com</h5>
                </div>
            </div>
            <div class="matchingBtnInside">
                <img src="../../assets/svg/next.svg" alt="" height="18px" width="18px" />
            </div>

            <div class="matchingImage">
                <figure>
                    <img src="/images/manager/matching/matching1.png" alt="미국 국기" />
                </figure>
                <div>
                    <h6 style="color: #502423;">
                        받은 회원
                    </h6>
                    <h3 style="color: #502423; font-weight: 700; display: inline-flex; align-items: center; ">
                        이 승 철
                        <span class="status">학생</span>
                    </h3>
                    <h5 style="font-weight: 350; margin-top: 24px;">032-222-3333</h5>
                    <h5 style="font-weight: 350;">asdfsadf@naver.com</h5>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'MatchingItemImages',
    props: {},
    data() {
        return {}
    }
}
</script>